import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';

@Component({
  selector: 'app-workbook-template',
  templateUrl: './workbook-template.component.html',
  styleUrls: ['./workbook-template.component.scss']
})
export class WorkbookTemplateComponent implements OnInit {
  selectAllVal: boolean = false;
  selectedStartDate: string;
  startDate1 = new Date();
  startDate = new FormControl(new Date());
  tomorrow = new Date();
  endDate = new FormControl(new Date());
  dateVariable = true;
  selectedInstance: any = null;
  date: any;
  public itemNumber = 0;
  public progressBarName = 'select';
  selectedValue: string;
  public sourceVal = [];
  configItem: any = [];
  public tracks = [];
  public tasks = [];
  targetInstance: any;
  batchKey: string;
  public configData = [];
  public configData1 = [];
  showArray = [];
  showArray1 = [];
  instanceList: any;
  moduleName: any;
  endDateReadonly = true;
  public submitNewBtnDisable: boolean = true;
  selectedEndDate: string;
  configTemplate: boolean = false;
  selected: any = [];
  selectedModule: any = [];
  isChecked = false;
  selectedFiles: any;
  fileName: any;
  fileUpload: string;
  fileUpload1: string;
  file: any;
  hideme = {};

  files: any[] = [{ WorkBook_Template: "Y", name: 'Use default template / BR100 file', checked: 'true' }, { WorkBook_Template: "N", name: 'Upload Workbook file', checked: 'false' }];

  selOpt: boolean = true;
  public progressBarArray1 = [{ name: "select", src: 'assets/select.png', index: 0 },
  { name: "submit", src: 'assets/submit.png', index: 1 },
  { name: "create", src: 'assets/create.png', index: 2 },
  ];


  hideOptions: boolean = true;
  isDisabled: boolean = true;
  start: any;
  selectedFile: any;
  batchStatus: any;
  events: string[] = [];
  end: any;

  uploadForm: FormGroup;
  constructor(public dialog: MatDialog, private formBuilder: FormBuilder
    , public _data: DataService,
    private compareService: CompareserviceService,
    private router: Router,
    private route: ActivatedRoute,
    private notification: NotificationService) {
    this.tomorrow.setDate(this.tomorrow.getDate());
    this.hideme = {};
  }

  ngOnInit(): void {
    if (this.compareService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      // this.getInstanceDetails(DconConfigAPI.API_VARIABLES.WORKBOOK);
      this.getConfigDetails(DconConfigAPI.API_VARIABLES.Request_Type_ConfigWorkbook);
      // this.batchKey = this.compareService.batchKey;
      // this.batchStatus = this.compareService.batchStatus;
      // this.uploadForm = this.formBuilder.group({
      //   fileData: [""],
      // });
    }
  }

  getConfigDetails(type) {
    this.maskPage();
    const data = [];
    this.compareService.getConfigDetails(type).subscribe((res) => {
      res?.Config_Details?.forEach((element,i) => {
        const obj = JSON.parse(element.details);
        const detailsObj = {
          TRACK: obj.TRACK,
          APPLICATION: obj.APPLICATION,
          APPLICATION_SHORT_CODE: obj.APPLICATION_SHORT_CODE,
          saveStatus: false,
          indexVal : i
        };
        data.push(detailsObj);
      });
      this.configData = data;
      data.forEach((element, index) => {
        this.tracks.push(element.TRACK);
        this.showArray[index] = false;
      });
      this.tracks = [...new Set(this.tracks)];
      this.unMaskPage();
    }, err => {
      this.unMaskPage();
      this.notification.showError('Something went wrong!');
    });
  }

  onSubmit() {
    this.router.navigate(["../createSubmit"], { relativeTo: this.route });
  }

  workbookCsvExtractPopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: "Task Status",
        mess: `Batch Key ${this.compareService.batchKey}: <b>Config Workbook - Process Submitted</b>`,
      }
    });

    dialogRef.afterClosed().subscribe(async(result) => {
      if (result = 'ok') {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.router.navigate(["/config-workbook/workbookcsv"]);
      }
    });
  }

  // check if the item are selected
  checked(item) {
    if (this.selected.indexOf(item) !== -1) {
      return true;
    }
  }

  // when checkbox change, add/remove the item from the array
  onChange(event, item, track) {
    const index = item.indexVal;
    if(event.checked){
      this.configData[index].saveStatus = true;
      const count = this.configData.filter(ele =>  ele.saveStatus === true).length;
      if(count === this.configData.length){
        this.selectAllVal = true;
      }
    }else{
      this.configData[index].saveStatus = false;
      const count = this.configData.filter(ele => ele.saveStatus === false).length;
      if(count !== this.configData.length){
        this.selectAllVal = false;
      }
    }
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }


  selectAll(event){
    if(event.checked){
      this.selectAllVal = true;
      this.showArray.forEach((ele,i)=>{
        this.showArray[i] = true;
        this.configData[i].saveStatus = true;
      });
    }else{
      this.selectAllVal = false;
      this.showArray.forEach((ele,i)=>{
        this.showArray[i] = false;
        this.configData[i].saveStatus = false;
      });
    }
  }

  downloadTemplates(){
    this.maskPage();
    const path = this._data.configTemplatePath;
    const a = DconConfigAPI.URL_PROPS.WORKBOOKTEMPLATE;
    const fileList = [];
    this.configData.forEach(ele =>{
      if(ele.saveStatus){
        const filepath = path + DconConfigAPI.URL_PROPS.WORKBOOKTEMPLATE +'\\'+ ele.APPLICATION +'_Workbook.xlsx';
        fileList.push(filepath);
      }     
    });
    const payLoad ={
      "fileList" : fileList
    };

    if (fileList.length > 0) {
      this.compareService.downloadTemplates(payLoad).subscribe(res => {
        if (res.byteLength === 1176) {
          this.notification.showError('Not able to download files');
        } else {
          this.writeContents(res, 'Workbook_Template.zip');
          this.unMaskPage();
          // this.dialogRef.close();
        }
      },
        (error) => {
          this.unMaskPage();
          console.log(error);
          this.notification.showError('Something went wrong!');
          // this.dialogRef.close();
        });
    } else {
      this.unMaskPage();
      this.notification.showError("There are no files list available to download !");
    }

    console.log("File List",payLoad);
  }



  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }



}
